__turbopack_context__.v({
  "HomePageSection": "_0sQVSq_HomePageSection",
  "PromoRibbon-instructional": "_0sQVSq_PromoRibbon-instructional",
  "PromoRibbon-retailer": "_0sQVSq_PromoRibbon-retailer",
  "contentHomepage": "_0sQVSq_contentHomepage",
  "grid-item": "_0sQVSq_grid-item",
  "h-card": "_0sQVSq_h-card",
  "h-card-details": "_0sQVSq_h-card-details",
  "instructional": "_0sQVSq_instructional",
  "large-2": "_0sQVSq_large-2",
  "promo-subheader": "_0sQVSq_promo-subheader",
  "promoImage": "_0sQVSq_promoImage",
  "promoItem": "_0sQVSq_promoItem",
  "v-card-img-top": "_0sQVSq_v-card-img-top",
});
